import "../css"
import "./datepicker"
import "./select2"
import { createMainCalendar, createNewCalendar } from "./setup-calendar"
import { updateNewRequest } from "./new-request"

let mainCalendar, newCalendar

addEventListener("turbo:load", function() {
  mainCalendar = createMainCalendar()
})

addEventListener("turbo:frame-load", function() {
  newCalendar = createNewCalendar()
  updateNewRequest(newCalendar)
  $("#modal").modal()
})

// index page vehicle filter
$(document).on("change", 'input[name="vehicle"]', function() {
  mainCalendar && mainCalendar.render()
})

$(document).on("change", "#request_start_at, #request_end_at, #request_all_day, #request_vehicle_id", function() {
  updateNewRequest(newCalendar)
})

$(document).on("hidden.bs.modal", "#modal", function() {
  $(this).modal("dispose").remove()
})
